import { useQuery } from "@tanstack/react-query";

import { validateStatusCode } from "common/helpers/HTTP";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";

interface UseFileProxyParams {
  accountId: string;
  url: string;
  disableQuery?: boolean;
}

async function fetchFileProxy(
  workspaceId: string,
  accountId: string,
  url: string,
) {
  const encodedUrl = encodeURIComponent(url);
  const token = localStorage.getItem("auth");

  const endpoint = `workspaces/${workspaceId}/accounts/${accountId}/file?url=${encodedUrl}`;
  const apiUrl = `${import.meta.env.VITE_API_URL}${endpoint}`;

  return fetch(apiUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then(validateStatusCode)
    .then(async (response) => {
      const blob = await response.blob();
      return blob;
    });
}

export default function useFileProxy({
  accountId,
  url,
  disableQuery = false,
}: UseFileProxyParams) {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const queryKey = [workspaceId, accountId, "fileProxy", url];

  const {
    data: fileProxyData,
    isLoading: isLoadingFileProxy,
    error: fileProxyError,
  } = useQuery({
    queryKey,
    queryFn: () => fetchFileProxy(workspaceId, accountId, url),
    enabled: !!workspaceId && !!accountId && !!url && !disableQuery,
  });

  return {
    fileProxyData,
    isLoadingFileProxy,
    fileProxyError,
  };
}
